import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { DocsIndex } from './screens/Index';

const DocsRoutes = (
  <Route
    path="/docs"
    render={() => (
      <Switch>
        <Route
          path="/docs/:scope?/:procedure?/:version?"
          component={DocsIndex}
        />
      </Switch>
    )}
  />
);

export { DocsRoutes };
